/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
    // Remove free sample if other products added to cart
    document.addEventListener("click", function(event) {
        let addToCartButton = event.target.closest("[data-add-to-cart]");

        if (addToCartButton) {
            setTimeout(() => {
                fetch("/cart.js")
                    .then(response => response.json())
                    .then(cart => {
                        let hasOtherProducts = false;
                        let hasTargetProduct = false;

                        cart.items.forEach(item => {
                            if (item.variant_id == 46150309937344) {
                                hasTargetProduct = true;
                            } else {
                                hasOtherProducts = true;
                            }
                        });

                        if (hasTargetProduct && hasOtherProducts) {
                            fetch("/cart/update.js", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                },
                                body: JSON.stringify({
                                    updates: {
                                        "46150309937344": 0
                                    }
                                }),
                            }).then(() => {
                                fetch("/cart.js") // Refresh cart
                                    .then(response => response.json())
                                    .then(updatedCart => console.log("Updated Cart:", updatedCart));
                            });
                        }
                    });
            }, 1000); // Increased delay to ensure the add-to-cart action completes
        }
    });
})();

